import styled from 'styled-components';
import { breakpoint } from '../../../constants/breakpoints';
import Text from '../../../ui/Text';
import React from 'react';
import { detectMobile } from '../../../utils/UiHelper';

export const PoolDetailsContainer = styled.div`
    height: auto;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 15px 0 0;
    @media screen and ${breakpoint.S} {
        margin-top: 25px;
        max-width: 100%;
        justify-content: space-between;
    }
    @media screen and ${breakpoint.MinL} {
        max-width: 100%;
        justify-content: space-between;
    }
`;

export const PoolDetailsItem = styled.div`
    height: auto;
    width: 160px;
    max-width: 160px;
    display: block;
    box-sizing: border-box;
    margin: 20px 20px 0 0;
    @media screen and ${breakpoint.S} {
        width: calc(50% - 10px);
        max-width: 100%;
        margin-right: 0;
    }
    @media screen and ${breakpoint.XS} {
        margin: 10px 0 0 0;
        width: calc(50% - 5px);
    }
    @media screen and ${breakpoint.MinL} {
        margin-right: 0;
        width: calc(50% - 10px);
        max-width: 100%;
    }
`;

export const PoolDetailsItemCard = styled.div`
    height: 70px;
    width: 100%;
    min-height: 70px;
    padding: 12px 5px 12px 10px;
    background: #fff;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    box-shadow: 0 5px 25px #dfe6fabf;
    border-radius: 5px;
    @media screen and ${breakpoint.MinL} {
        height: auto;
        padding: 14px 32px;
        align-items: center;
    }
`;

export const PoolDetailsIcon = styled.div`
    height: 45px;
    width: 45px;
    background: #e7f6ef;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    box-sizing: border-box;
    @media screen and ${breakpoint.MinL} {
        width: 52px;
        height: 52px;
    }
`;

export const PoolDetailsDescription = styled.div`
    height: auto;
    width: calc(100% - 45px);
    display: block;
    box-sizing: border-box;
    padding: 0 0 0 10px;
    @media screen and ${breakpoint.XS} {
        & > .pool-details-description {
            font-size: 17px;
        }
    }
    @media screen and ${breakpoint.MinL} {
        width: calc(100% - 52px);
    }
    @media screen and ${breakpoint.XS} {
        & > .pool-details-description {
            font-size: 17px;
        }
    }
`;

export const PoolCharacteristics = ({ icon, label, description }) => {
    return (
        <PoolDetailsItemCard>
            <PoolDetailsIcon>
                <img src={icon} alt="" />
            </PoolDetailsIcon>
            <PoolDetailsDescription>
                <Text
                    size={'x2'}
                    bold
                    color={'#333'}
                    padding={'0'}
                    margin={'0'}
                    lh={'18'}
                    className="pool-details-description"
                >
                    {label}
                </Text>
                <Text
                    size={'x1'}
                    color={'#333'}
                    padding={'0'}
                    margin={detectMobile() ? '5px 0 0' : '0'}
                    lh={'18'}
                >
                    {description}
                </Text>
            </PoolDetailsDescription>
        </PoolDetailsItemCard>
    );
};
